import { createSlice } from "@reduxjs/toolkit";
export const OTPCounterSlice = createSlice({
  name: "OTPCounter",
  initialState: {
    OTPCounterTime: 0,
  },
  reducers: {
    getOTPCounterTime: (state, action) => {
      state.OTPCounterTime = action.payload;
    },
  },
});
export const { getOTPCounterTime } =
  OTPCounterSlice.actions;
export default OTPCounterSlice.reducer;
